<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">Castle Kidnapped</h1>
<p class="author">John Dechancie</p>
<p class="colophon"><img alt="Open Road logo" src="images/logo.png" width="60%"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section1.vue?8fe8ef44